<core-ui-dialog-base
  title="{{ 'NAVBAR.ADD_NEW_DIALOG.TITLE' | translate }}"
  button="{{ 'NAVBAR.ADD_NEW_DIALOG.BUTTON' | translate }}"
  [disabled]="!value || (value === AddNewType.Exception && !profile)"
  (buttonClick)="create()"
>
  <core-ui-select-card [options]="options" [(value)]="value"></core-ui-select-card>
  @if (value === AddNewType.Exception) {
    <div class="profile-selector-wrapper">
      <mat-form-field>
        <mat-select
          [(value)]="profile"
          placeholder="{{ 'NAVBAR.ADD_NEW_DIALOG.SELECT_PROFILE' | translate }}"
        >
          @for (profile of profiles$ | async; track profile.id) {
            <mat-option [value]="profile">{{ profile.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
</core-ui-dialog-base>
